import React, { useState } from "react";
import { Button, Icon, Modal, Header, Image, Label, Divider, Card, Checkbox, Item } from "semantic-ui-react";
import { Field, Formik } from "formik";
import * as Yup from "yup";
import CustomInputTextComponent from "components/Form/CustomInputTextComponent";
import TubeDepositCard from "../TubeDepositCard";
import { toast } from "react-toastify";

const schemaValidationDepotExpress = Yup.object().shape({
	ordon: Yup.string().required("Champ requis"),
});

const ExpressDepositModal = ({ open, close, createDepositExpress, packs, center }) => {
	const [pack, setPack] = useState(null);
	const [fast, setFast] = useState(false);
	const [tubes, setTubes] = useState([]);
	const [documents, setDocuments] = useState([]);
	const [selectedTube, setSelectedTube] = useState([]);

	const pushBarCode = (barcode, setFieldValue, val, values) => {
		if (barcode.trim().length === 10 && setFieldValue && !tubes.some((t) => t.barcode === barcode.trim())) {
			if (tubes.some((t) => t.barcode === barcode)) {
				toast.warn("Code-barres déjà utilisé pour un tube.");
				return;
			}
			if (
				Object.entries(values)
					.filter((v) => v[0] !== val)
					.some((v) => v[1] === barcode)
			) {
				toast.warn("Code-barres déjà utilisé pour un document.");
				setFieldValue(val, "");
				return;
			}

			setFieldValue(val, barcode.trim());
			setSelectedTube(getDefaultSelectedTube(pack));
		}
	};

	const handleKeyDown = (event, values, setFieldValue, val) => {
		if (event.key === "Enter") {
			if (values["scan"].trim().length === 10) pushBarCode(values[val], setFieldValue, val, values);
		}
	};
	const handleKeyUp = (event, values, setFieldValue, val) => {
		pushBarCode(values[val], setFieldValue, val, values);
	};

	const getDefaultTubes = (pack) => {
		if (
			packs &&
			pack &&
			packs.some((p) => p.id === pack) &&
			packs?.filter((p) => p.id === pack)[0].analysesPackages.flatMap((ap) => ap.analysis.tubes)
		) {
			return packs
				?.filter((p) => p.id === pack)[0]
				.analysesPackages.flatMap((ap) => ap.analysis.tubes)
				.map((t) => {
					return { ...t, barcode: "", canceled: false };
				});
		}
		return [];
	};

	const getDefaultDocuments = (pack) => {
		if (
			packs &&
			pack &&
			packs.some((p) => p.id === pack) &&
			packs?.filter((p) => p.id === pack)[0].analysesPackages.flatMap((ap) => ap.analysis.documents)
		) {
			return packs?.filter((p) => p.id === pack)[0].analysesPackages.flatMap((ap) => ap.analysis.documents);
		}
		return [];
	};

	const getDefaultSelectedTube = (pack) => {
		if (
			packs &&
			pack &&
			packs.some((p) => p.id === pack) &&
			packs?.filter((p) => p.id === pack)[0].analysesPackages.flatMap((ap) => ap.analysis.tubes)[0]
		) {
			return packs
				?.filter((p) => p.id === pack)[0]
				.analysesPackages.flatMap((ap) => ap.analysis.tubes)
				.filter((t) => !t.barcode || t.barcode === "")[0];
		} else {
			return null;
		}
	};

	const scanBarcode = (barcode, values) => {
		if (Object.entries(values).some((v) => v[1] === barcode && v[0] !== "scan")) {
			toast.warn("Code-barres déjà utilisé pour un document.");
			return;
		}
		if (selectedTube && tubes.some((t) => t.id === selectedTube.id) && !tubes.some((t) => t.barcode === barcode.trim())) {
			tubes.filter((t) => t.id === selectedTube.id)[0].barcode = barcode;
			setTubes(tubes);
			setSelectedTube(null);
		}
	};
	const setTubeNotPresent = (tube, cancel = false) => {
		if (tube && tubes.some((t) => t === tube)) {
			tubes.filter((t) => t === tube)[0].canceled = !cancel;
			setTubes(tubes);
		}
		setSelectedTube(null);
	};
	const submitDepotExpress = async (values, setFieldValue, andClose) => {
		delete values["scan"];
		let data = {
			pack: pack,
			barcodes: values,
			center: center,
			tubes: tubes.map((t) => {
				return { id: t.id, barcode: t.barcode, canceled: t.canceled };
			}),
		};
		await createDepositExpress(data)
			.then((res) => {
				if (res.error?.response?.data?.length) {
					const errors = res.error.response.data.map((e) => e.error).join(", ");
					toast.error(
						`${res.error.response.data.length} erreur${
							res.error.response.data.length > 1 ? "s" : ""
						} lors de l'enregistrement du dépôt express : ${errors}`
					);
				} else if (res.payload.status === 200) {
					toast.success("Dépôt express enregistré avec succès");
					resetForm(values, setFieldValue, andClose);
				} else {
					toast.error("Erreur lors de l'enregistrement du dépôt express");
				}
			})
			.catch((err) => {
				toast.error("Erreur lors de l'enregistrement du dépôt express");
			});
	};
	const resetForm = (values, setFieldValue, andClose) => {
		if (andClose) setPack(null);
		setTubes(andClose ? [] : getDefaultTubes(pack));
		setSelectedTube(null);
		if (andClose) {
			Object.keys(values)
				.filter((k) => k !== "ordon")
				.map((k) => delete values[k]);
			setFieldValue("ordon", "");
		} else {
			Object.keys(values).map((k) => setFieldValue(k, ""));
		}

		if (andClose) close();
	};

	//Behavior with the fast encoding (douchette)
	const handleKeyDownFast = (event, values, setFieldValue, val) => {
		if (event.key === "Enter") {
			if (values["scan"].trim().length === 10) pushFastBarCode(values["scan"].trim(), setFieldValue, values);
			else toast.warn("Le format du code-barres n'est pas celui attendu.");
		}
	};
	const pushFastBarCode = (barcode, setFieldValue, values) => {
		//Barcode png used to validate the modal with the barcode reader
		if (values.ordon === "") {
			setFieldValue("ordon", barcode);
			setFieldValue("scan", "");
			setSelectedTube(getDefaultSelectedTube(pack));
			return;
		}

		if (values.ordon !== "" && tubes && tubes.length > 0 && selectedTube && tubes.some((t) => t.id === selectedTube.id)) {
			if (values.ordon !== barcode) {
				scanBarcode(barcode, values);
				setFieldValue("scan", "");
			} else {
				setFieldValue("scan", "");
				toast.error("Ce code-barres est déjà utilisé pour l'ordonnance.");
			}
			return;
		}
		if (barcode === "mylabnurse") {
			if (isExpressValid(values)) {
				setFieldValue("scan", "");
				submitDepotExpress(values, setFieldValue, false);
			} else {
				toast.warn("Informations manquantes pour créer un dépôt express.");
			}
			return;
		}
		toast.warn("Le code-barres scanné n'est pas celui attendu pour valider le dépôt.");
	};

	const getFastEncodingInfo = (pack, values) => {
		let result = [];
		if (values.ordon !== "" && packs && pack && packs.some((p) => p.id === pack) && packs?.filter((p) => p.id === pack)[0].analysesPackages) {
			result.push(
				<span>
					Ordonnance : <Icon name="barcode" /> {values.ordon}
				</span>
			);
		}
		if (tubes && tubes.length > 0 && !tubes.some((t) => t.barcode === "" && t.canceled === false)) {
			result.push(
				<span>
					{tubes
						.filter((t) => t.barcode)
						.map((t) => (
							<Item key={`bc-${t.label}`}>
								{t.label} : <Icon name="barcode" /> {t.barcode}
							</Item>
						))}
				</span>
			);
		}
		return result;
	};
	const getFastToEncode = (pack, values) => {
		if (values.ordon === "" && packs && pack && packs.some((p) => p.id === pack) && packs?.filter((p) => p.id === pack)[0].analysesPackages) {
			return (
				<span>
					Ordonnance <span style={{ color: "red" }}>*</span>
				</span>
			);
		}
		if (packs && pack && packs.some((p) => p.id === pack) && packs?.filter((p) => p.id === pack)[0].analysesPackages) {
			let docs = packs?.filter((p) => p.id === pack)[0].analysesPackages.flatMap((ap) => ap.analysis.documents);
			if (docs.length > 0) {
				return docs[0].title;
			}
		}
		if (packs && pack && packs.some((p) => p.id === pack) && packs?.filter((p) => p.id === pack)[0].analysesPackages) {
			return packs
				?.filter((p) => p.id === pack)[0]
				.analysesPackages.flatMap((ap) => ap.analysis.tubes)
				.map((t) => t.label);
		}
	};

	const isExpressValid = (values) => {
		return pack && tubes && tubes.length > 0 && !tubes.some((t) => t.barcode === "" && t.canceled === false) && values.ordon !== "";
	};
	return (
		<Modal size={"small"} open={open} closeOnEscape closeOnDimmerClick onClose={close}>
			<Modal.Header>
				<div style={{ display: "flex", justifyContent: "space-between" }}>
					<Header as="h2" content={`Dépôt Express ${pack ? packs?.filter((p) => p.id === pack)[0].label : ""} `} />
					{pack && packs?.filter((p) => p.id === pack)[0].label === "FCV" && (
						<Checkbox toggle label="Encodage à la douchette" checked={fast} onChange={(e, data) => setFast(data.checked)} />
					)}
				</div>
			</Modal.Header>
			<Formik
				enableReinitialize
				initialValues={{
					ordon: "",
					scan: "",
				}}
				validationSchema={schemaValidationDepotExpress}
				onSubmit={(values) => {
					createDepositExpress();
					close();
				}}
			>
				{({ submitForm, values, setFieldValue }) => (
					<>
						<Modal.Content>
							{(!pack || !fast) && (
								<div>
									<Header as="h2" icon textAlign="center">
										<Header.Content>Analyses</Header.Content>
									</Header>
									<Header as="h3" textAlign="center">
										{packs.map((p) => (
											<Label
												key={p.id}
												as="a"
												basic
												color={pack === p.id ? "teal" : "grey"}
												data={p.id}
												onClick={(e, packSelected) => {
													if (!pack) setFast(packs && packSelected && packs.some((p) => p.id === packSelected.data && p.label === "FCV"));
													setPack(packSelected.data);
													setSelectedTube(getDefaultSelectedTube(packSelected.data));
													setTubes(getDefaultTubes(packSelected.data));
													setDocuments(getDefaultDocuments(packSelected.data));
												}}
											>
												{p.label}
											</Label>
										))}
										<br />
									</Header>
								</div>
							)}
							{fast && pack && (
								<div style={{ display: "flex", justifyContent: "center" }}>
									<Card>
										<Card.Content>
											<Card.Header style={{ fontSize: "0.9rem" }}>
												{getFastEncodingInfo(pack, values).map((e, index) => (
													<div style={{ fontSize: "1.2em" }} key={`encoding-${index}`}>
														{e}
													</div>
												))}
											</Card.Header>

											<Card.Description>
												{isExpressValid(values) && (
													<div>
														Scanner ce code-barre pour valider
														<Image src={window.location.origin + "/barcode/mylabnurse.png"} height="100" />{" "}
													</div>
												)}
												<Field
													autoFocus
													component={CustomInputTextComponent}
													name="scan"
													customlabel={
														!isExpressValid(values) ? (
															<span>
																<Icon name="barcode" />
																{getFastToEncode(pack, values)} :{" "}
															</span>
														) : (
															<span></span>
														)
													}
													onKeyDown={(e) => {
														handleKeyDownFast(e, values, setFieldValue);
													}}
												/>
											</Card.Description>
										</Card.Content>
									</Card>
								</div>
							)}
							{!fast && pack && (
								<>
									<br />
									<Divider />
									<br />
									<div>
										<Header as="h2" textAlign="center">
											<Header.Content>
												<Icon name="id card" circular /> Documents attendus
											</Header.Content>
										</Header>
										<Card.Group style={{ display: "flex", flexWrap: "wrap" }}>
											<Card>
												<Card.Content>
													<Card.Header style={{ fontSize: "0.9rem" }}>
														Ordonnance<span style={{ color: "red" }}>*</span>
													</Card.Header>
													<Card.Description>
														<Field
															autoFocus
															component={CustomInputTextComponent}
															name="ordon"
															customlabel={<Icon name="barcode" />}
															onKeyDown={(e) => {
																handleKeyDown(e, values, setFieldValue, "ordon");
															}}
															onKeyUp={(e) => {
																handleKeyUp(e, values, setFieldValue, "ordon");
															}}
														/>
													</Card.Description>
												</Card.Content>
											</Card>
											{pack &&
												documents &&
												documents.length > 0 &&
												documents.map((d) => (
													<Card>
														<Card.Content>
															<Card.Header style={{ fontSize: "0.9rem" }}>{d.title}</Card.Header>
															<Card.Description>
																<Field
																	component={CustomInputTextComponent}
																	name={d.name}
																	customlabel={<Icon name="barcode" />}
																	onKeyDown={(e) => handleKeyDown(e, values, setFieldValue, d.name)}
																	onKeyUp={(e) => handleKeyUp(e, values, setFieldValue, d.name)}
																/>
															</Card.Description>
														</Card.Content>
													</Card>
												))}
										</Card.Group>
									</div>
									<br />
									<Divider />
									<br />
									<div>
										<>
											<Header as="h2" textAlign="center">
												<Header.Content>
													<Icon name="lab" circular />
													Tubes
												</Header.Content>
											</Header>

											{pack && tubes && (
												<Card.Group style={{ display: "flex", flexWrap: "wrap" }}>
													{tubes.map((t, index) => (
														<TubeDepositCard
															key={index}
															tube={t}
															openBarcode={setSelectedTube}
															isSelected={selectedTube?.id === t.id}
															submitBarCode={(bc) => scanBarcode(bc.trim(), values)}
															cancelSelect={() => setSelectedTube(null)}
															selectTube={() => setSelectedTube(t)}
															setTubeNotPresent={setTubeNotPresent}
														/>
													))}
												</Card.Group>
											)}
										</>
									</div>
								</>
							)}
						</Modal.Content>
						{!fast && (
							<Modal.Actions>
								<Button content="Annuler" onClick={() => resetForm(values, setFieldValue, true)} />
								<Button
									primary
									content="Enregistrer et fermer"
									onClick={() => submitDepotExpress(values, setFieldValue, true)}
									disabled={!isExpressValid(values)}
								/>
								<Button
									primary
									content="Enregistrer et ajouter un autre dépôt"
									onClick={() => submitDepotExpress(values, setFieldValue, false)}
									disabled={!isExpressValid(values)}
								/>
							</Modal.Actions>
						)}
					</>
				)}
			</Formik>
		</Modal>
	);
};
export default ExpressDepositModal;
